import { _values, removeDBObjectKeys, tsValidate, tsValidateArray, tsValidateBoolean, tsValidateNumber, tsValidateOptionalId, tsValidateResult, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { findingSourceTypesEnum } from '../runtime/runtime-finding/types.js';
import { AdvisorRuntimeIDBGroup } from '../runtime/_core/consts.js';
const Validator_BaseRawFinding = {
    type: tsValidateValue(['numeric', 'enumerated']),
    variableId: tsValidateUniqueId,
    isChiefComplaint: tsValidateBoolean(),
    snippetId: tsValidateOptionalId,
    findingId: tsValidateOptionalId,
    parentId: tsValidateOptionalId,
    source: tsValidateValue(_values(findingSourceTypesEnum), false),
    isPartialCalculation: tsValidateBoolean(false),
    children: tsValidateArray((instance) => {
        return tsValidateResult(instance, Validator_SuggestedFinding);
    }),
};
const Validator_SuggestedFindingAttribute = {
    type: tsValidateValue(['enumerated']),
    variableId: tsValidateUniqueId,
    valueIds: tsValidateArray(tsValidateUniqueId, false),
};
const Validator_EnumSuggestedFinding = {
    ...Validator_BaseRawFinding,
    type: tsValidateValue(['enumerated']),
    valueIds: tsValidateArray(tsValidateUniqueId),
    attributes: tsValidateArray(Validator_SuggestedFindingAttribute, false),
};
const Validator_NumericSuggestedFinding = {
    ...Validator_BaseRawFinding,
    type: tsValidateValue(['numeric']),
    measurementUnitId: tsValidateUniqueId,
    value: tsValidateNumber(),
};
const Validator_SuggestedFinding = (instance) => {
    if (!instance)
        return 'suggested findings was not provided for validation';
    // remove db object keys for validation, this actually seems like a bug in the infra but needs another look
    const _instance = removeDBObjectKeys(instance);
    switch (_instance.type) {
        case 'enumerated':
            return tsValidate(_instance, Validator_EnumSuggestedFinding);
        case 'numeric':
            return tsValidate(_instance, Validator_NumericSuggestedFinding);
    }
};
const Validator_GeneratedProps = {};
export const DBDef_SuggestedFinding = {
    modifiablePropsValidator: Validator_SuggestedFinding,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'suggested-findings',
    entityName: 'Suggested Finding',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'suggested-findings'
    },
    backend: {
        name: 'suggested-findings'
    }
};
//# sourceMappingURL=db-def.js.map